import React, { useRef, useEffect } from "react";
import Globe from "react-globe.gl";
import "./ExportGlobe.css";

const ExportGlobe = () => {
  const globeRef = useRef();

  // 🌍 Destination Markers (with Muar as the origin)
  const markers = [
    { lat: 2.0500, lng: 102.5667, label: "Muar, Malaysia" },       // Starting point
    { lat: 1.3521, lng: 103.8198, label: "Singapore" },            // 🇸🇬
    { lat: 4.5353, lng: 114.7277, label: "Brunei" },               // 🇧🇳
    { lat: 39.9042, lng: 116.4074, label: "Beijing, China" },      // 🇨🇳
    { lat: -33.8688, lng: 151.2093, label: "Sydney, Australia" },  // 🇦🇺
    { lat: 51.5074, lng: -0.1278, label: "London, UK" },           // 🇬🇧
    { lat: 40.7128, lng: -74.0060, label: "New York, USA" },       // 🇺🇸
  ];
  

  // 🧭 Export Routes from Muar
  const arcs = markers
    .filter((m) => m.label !== "Muar, Malaysia")
    .map((m) => ({
      startLat: 2.0500,
      startLng: 102.5667,
      endLat: m.lat,
      endLng: m.lng,
    }));

  // 🏷️ Label Data for country/city names
  const labels = markers.map((m) => ({
    lat: m.lat,
    lng: m.lng,
    text: m.label,
  }));

  // 🔁 Auto Rotate + Zoom Out
  useEffect(() => {
    if (!globeRef.current) return;

    const controls = globeRef.current.controls();
    controls.autoRotate = true;
    controls.autoRotateSpeed = 0.5;

    globeRef.current.pointOfView({ lat: 2.05, lng: 102.57, altitude: 5 }, 1500);
  }, []);

  return (
    <div className="globe-wrapper">
        <Globe
        ref={globeRef}
        globeImageUrl="//unpkg.com/three-globe/example/img/earth-dark.jpg"
        backgroundColor="rgba(0,0,0,0)"
        pointsData={markers}
        pointLat="lat"
        pointLng="lng"
        pointColor={() => "#FF5722"}
        pointAltitude={0.05}
        arcsData={arcs}
        arcColor={() => "#FF5722"}
        arcAltitude={0.2}
        arcStroke={1.2}
        arcDashLength={0.4}
        arcDashGap={1}
        arcDashAnimateTime={3000}

        labelsData={labels}
        labelLat="lat"
        labelLng="lng"
        labelText="text"
        labelLabel="text"         // 👈 this is the key!
        labelSize={() => 3}
        labelDotRadius={0.3}
        labelAltitude={0.1}
        labelColor={() => "#FFFFFF"}
        />

    </div>
  );
};

export default ExportGlobe;
